import React from "react";
import { clients } from "../data/content";

function Clients() {
  return (
    <section id="clients" className="section">
      <div className="container">
        <div className="section-head" data-reveal>
          <p className="eyebrow">Clients &amp; projects</p>
          <h2 className="section-title">Selected engagements</h2>
          <p className="section-lead">
            A snapshot of the organizations we've helped build smarter, data-driven products.
          </p>
        </div>
        <div className="case-grid" data-reveal>
          {clients.map((c) => (
            <article className="case-card" key={c.name}>
              <div className="case-logo">
                <img src={c.logo} alt={`${c.name} logo`} loading="lazy" />
              </div>
              <span className="case-cat">{c.category}</span>
              <h3>{c.name}</h3>
              <p>{c.project}</p>
            </article>
          ))}
          <article className="case-card case-card-cta">
            <div>
              <p className="eyebrow eyebrow-light">Your organization</p>
              <h3>Have a data or application project in mind?</h3>
              <p>We'd welcome the chance to understand your requirements and propose an approach.</p>
            </div>
            <a href="#contact" className="text-link">
              Start a conversation <i className="fa-solid fa-arrow-right" aria-hidden="true" />
            </a>
          </article>
        </div>
      </div>
    </section>
  );
}

export default Clients;
